/*
 * @Description:
 * @Author: zhanjunwei
 * @Date: 2025-01-02 17:01:20
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2025-01-02 17:12:23
 */
'use client';
import { useEffect, useState } from 'react';
import { useSiblingStore } from './useSiblingStore';

const screens = {
  mobile: { max: '768px' },
  desktop: { max: '1024px', min: '769px' },
  mobileSM: { max: '640px' },
  xs: { max: '375px' },
};

type KeyType = keyof typeof screens;
const calcMedia = (breakpoint: KeyType): MediaQueryList => {
  const value = screens[breakpoint];
  return window.matchMedia(`(max-width: ${value.max})`);
};

export const useMedia = (breakpoint: KeyType) => {
  const [match, setMatch] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    const query = calcMedia(breakpoint);
    const mediaQuery =
      breakpoint === 'mobile' && query?.matches ? 'mobile' : 'pc';
    useSiblingStore.setState({ mediaQuery });
    setMatch(query.matches);

    const listener = (event: MediaQueryListEvent) => {
      const mediaQuery =
        breakpoint === 'mobile' && query.matches ? 'mobile' : 'pc';
      useSiblingStore.setState({ mediaQuery });
      setMatch(event.matches);
    };

    query.onchange = listener;
  }, []);

  return match as boolean;
};

export const getMobile = () => {
  if (typeof window === 'undefined') return false;
  const query = calcMedia('mobile');
  return query.matches;
};
